module.exports = __webpack_public_path__ + "static/media/014-cloud-8.0c9f38dc.svg";